'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const keyPressHelper = (callback)=>(e, ...args)=>{
        if (callback && (e.key === 'Enter' || e.key === 'Spacebar' || e.key === ' ')) {
            e.preventDefault();
            return callback(...args);
        }
        return undefined;
    };

exports.keyPressHelper = keyPressHelper;
//# sourceMappingURL=accessibility.js.map
